import styled, { css } from 'styled-components';
import { darken, getContrast } from 'polished';

function getConstrastColor(color?: string) {
  if (!color) return '#fff';
  return getContrast(color, '#fff') > 4 ? '#dedede' : '#3d3d3d';
}

export const Container = styled.tr<{
  descricaoFeriado?: string;
  cor_professor?: string;
  alocacao_pendente?: boolean;
}>`
  position: relative;
  cursor: pointer;
  transition: 0.2s;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textBackground};

  &:nth-child(odd) {
    background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

    &:hover {
      background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
    }
  }

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
  }

  &.feriado {
    font-weight: bold;
    background-color: ${({ theme }) => theme.colors.error};
    color: ${({ theme }) => theme.colors.textError};

    &:hover {
      background-color: ${({ theme }) => darken(0.1, theme.colors.error)};
    }
  }

  &.fim-semana {
    font-weight: bold;
    background-color: ${({ theme }) => theme.colors.warning};
    color: ${({ theme }) => theme.colors.textWarning};

    &:hover {
      background-color: ${({ theme }) => darken(0.1, theme.colors.warning)};
    }
  }

  ${({ cor_professor }) =>
    cor_professor &&
    css`
      background-color: ${cor_professor} !important;
      color: ${getConstrastColor(cor_professor)} !important;

      &:hover {
        background-color: ${darken(0.1, cor_professor)} !important;
      }
    `}

  ${({ alocacao_pendente }) =>
    alocacao_pendente &&
    css`
      color: ${({ theme }) => theme.colors.error};
      font-weight: 600;
    `}
`;

export const Coluna = styled.td`
  height: 20px;
  padding: 5px;
  border: 1px solid ${({ theme }) => theme.colors.background};
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })``;
